import script from "./tracking-page.vue?vue&type=script&setup=true&lang=js"
export * from "./tracking-page.vue?vue&type=script&setup=true&lang=js"

import "./tracking-page.vue?vue&type=style&index=0&id=8b639b30&lang=css"

const __exports__ = script;

export default __exports__